import { z } from "zod";
import { useParams } from "react-router-dom";

export function useSkillId() {
  const { skillId } = useParams();
  return z.string().min(1).parse(skillId);
}
